export function teamMemberFilters() {
    document.querySelectorAll('.team-members').forEach(section => {
        const filters = section.querySelector('.team-members__filters');
        const grid = section.querySelector('.team-members__grid');
        if (!filters || !grid) return;

        const chips = [...filters.querySelectorAll('.filter-chip')];
        const members = [...grid.querySelectorAll('.team-member')];
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        let animation;
        let activeCategory = 'all';

        filters.hidden = false;
        filters.addEventListener('click', event => {
            const chip = event.target.closest('.filter-chip');
            if (!chip || !filters.contains(chip)) return;
            const category = chip.dataset.teamCategory;
            if (category === activeCategory) return;
            activeCategory = category;
            chips.forEach(button => button.setAttribute('aria-pressed', String(button === chip)));

            animation?.kill();
            window.gsap?.set(members, { clearProps: 'opacity,transform,transition' });
            const applyFilter = () => {
                members.forEach(member => {
                    member.hidden = category !== 'all'
                        && !member.dataset.teamCategories.split(' ').includes(category);
                });
                window.ScrollTrigger?.refresh();
            };

            if (!window.gsap || reducedMotion.matches) {
                applyFilter();
                grid.style.removeProperty('opacity');
                return;
            }

            animation = window.gsap.timeline()
                .to(grid, { opacity: 0, duration: 0.15, ease: 'power1.out' })
                .add(() => {
                    applyFilter();
                    window.gsap.set(grid, { clearProps: 'opacity' });
                    const visibleMembers = members.filter(member => !member.hidden);
                    // Prevent the cards' CSS hover transition from delaying GSAP.
                    window.gsap.set(visibleMembers, { transition: 'none' });
                    animation = window.gsap.fromTo(visibleMembers,
                        { opacity: 0, y: 16 },
                        {
                            opacity: 1,
                            y: 0,
                            duration: 0.4,
                            stagger: { each: 0.045, amount: Math.min(0.25, Math.max(0, visibleMembers.length - 1) * 0.045) },
                            ease: 'power2.out',
                            clearProps: 'opacity,transform,transition',
                        }
                    );
                });
        });
    });
}
